module.exports = new __parcel__URL__("libultrahdr-esm.c9dc1563.wasm").toString();